export enum TransportMode {
  Legacy = 'LEGACY',
  Local = 'LOCAL',
  SSH = 'SSH',
  Netcat = 'SSH+NETCAT',
}
